/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1789948800000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Sep 21 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "knock",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Knock",
          "depth": 0,
          "id": "connect-to-knock"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing users",
          "depth": 1,
          "id": "syncing-users"
        }, {
          "value": "Syncing objects",
          "depth": 1,
          "id": "syncing-objects"
        }, {
          "value": "Syncing audiences",
          "depth": 1,
          "id": "syncing-audiences"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      ul: "ul",
      li: "li",
      code: "code",
      h3: "h3",
      h4: "h4"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Users"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to Knock ", _jsx(_components.a, {
                href: "https://docs.knock.app/concepts/users",
                children: "users"
              })]
            }), _jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.knock.app/api-reference/users",
                children: "Users docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Objects"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to Knock ", _jsx(_components.a, {
                href: "https://docs.knock.app/concepts/objects",
                children: "objects"
              })]
            }), _jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.knock.app/api-reference/objects",
                children: "Objects docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Audiences"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to Knock ", _jsx(_components.a, {
                href: "https://docs.knock.app/concepts/audiences",
                children: "audiences"
              })]
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.knock.app/api-reference/audiences",
                children: "Audiences docs"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-knock",
        children: "Connect to Knock"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Knock"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Knock"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "Enter the following fields into Hightouch:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Secret API key"
          }), ": You can find this in the Knock dashboard under ", _jsx(_components.code, {
            children: "API keys"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["(Optional) ", _jsx(_components.strong, {
            children: "Service token"
          }), ": This is only required if you plan to sync audiences. You can find this in the Knock dashboard under ", _jsx(_components.code, {
            children: "Service tokens"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Knock destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Knock destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-users",
        children: "Syncing users"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync data from any source to Knock ", _jsx(_components.a, {
          href: "https://docs.knock.app/concepts/users",
          children: "users"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to users in Knock, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync user fields via ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "field mapping"
        }), ".\nYou can map data from any of your model columns to default and custom user fields.\nIf you send data for a custom field that doesn't exist, Hightouch adds the field.\nEnsure your model's columns have the same data types as the fields you want to sync to."]
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. You have the following options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the user in Knock with all its synced fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete"
              })
            }), _jsx(_components.td, {
              children: "Delete the synced users from Knock"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-objects",
        children: "Syncing objects"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync data from any source to Knock ", _jsx(_components.a, {
          href: "https://docs.knock.app/concepts/objects",
          children: "objects"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to objects in Knock, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information.\nYou can also optionally map the following fields:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Email"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Phone number"
          })
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior-1",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. You have the following options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the object in Knock with all its synced fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete"
              })
            }), _jsx(_components.td, {
              children: "Delete the synced objects from Knock"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-audiences",
        children: "Syncing audiences"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync data from any source to Knock ", _jsx(_components.a, {
          href: "https://docs.knock.app/concepts/audiences",
          children: "audiences"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-audience-or-create-a-new-one",
        children: "Select an existing audience or create a new one"
      }), "\n", _jsx(_components.p, {
        children: "You can create a new audience or sync to an existing one. When creating a new audience, you can optionally enter a name. If you leave it blank, Hightouch uses the name of the model. To use an existing audience, select it from the dropdown."
      }), "\n", _jsx(_components.p, {
        children: "Hightouch creates the audience in Knock during the first sync run."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to audiences in Knock, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync user fields via ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "field mapping"
        }), ".\nYou can map data from any of your model columns to default and custom user fields.\nIf you send data for a custom field that doesn't exist, Hightouch adds the field.\nEnsure your model's columns have the same data types as the fields you want to sync to."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
